export enum CoreLevelFeatureNames {
  connectedAccounts = 'connected accounts',
  userManagement = 'user management',
  notificationSettings = 'notification settings',
  folderManagement = 'folder management',
  menuManagement = 'menu management',
  listingsManagement = 'listings management',
  promptManagement = 'prompt management',
  emailedReports = 'emailed reports',
  labelManagement = 'review labels',
  templateManagement = 'review templates',
  socialManagementPageManage = 'page manage',
  socialManagementPosts = 'posts',
  socialManagementPostsPublishSchedule = 'post publish/schedule',
  socialManagementRespondPostComments = 'respond post comments',
  socialManagementDirectMessages = 'direct messages',
}

export const CORE_LEVEL_PERMISSIONS_IDS: {
  [k in CoreLevelFeatureNames]: string
} = {
  [CoreLevelFeatureNames.connectedAccounts]: '76b58224-57a8-4878-905d-691b7963d16e',
  [CoreLevelFeatureNames.userManagement]: '929ade7f-8c99-491c-be4e-2a41890177e7',
  [CoreLevelFeatureNames.notificationSettings]: '4a47892f-04ca-4998-9765-ace80a502d94',
  [CoreLevelFeatureNames.folderManagement]: 'aa22de62-d16a-472a-b8cc-4eb497ebebbe',
  [CoreLevelFeatureNames.menuManagement]: '2b3f6e22-48cb-4ce2-bb90-f9bf9e7712d3',
  [CoreLevelFeatureNames.listingsManagement]: 'cefe11cc-6bf5-421c-b433-146a25ad2834',
  [CoreLevelFeatureNames.promptManagement]: 'bebdc10a-3fd3-40cb-888c-e2311c3bcefc',
  [CoreLevelFeatureNames.emailedReports]: '5022febc-f5f6-4669-be96-9dc98b3612e4',
  [CoreLevelFeatureNames.labelManagement]: '7e28f320-bb50-4549-b21c-a8c46d7724a8',
  [CoreLevelFeatureNames.templateManagement]: '92073e66-a35e-4861-96a7-4895569a5128',
  [CoreLevelFeatureNames.socialManagementPageManage]: 'd924de0e-35af-40fe-b226-dab6f0822f32',
  [CoreLevelFeatureNames.socialManagementPosts]: '6ada9576-b251-486c-a47b-f0037c3bb50a',
  [CoreLevelFeatureNames.socialManagementPostsPublishSchedule]:
    'e55db002-ae60-4878-a874-cbe644a0200e',
  [CoreLevelFeatureNames.socialManagementRespondPostComments]:
    'c1a83878-d837-417c-860d-8827c0ca3dec',
  [CoreLevelFeatureNames.socialManagementDirectMessages]: '6c3f77c1-f8e1-4169-8283-f6e0d4083c52',
}

export interface CorePermissionFeatureProps {
  canAffectStore: false
  id: string
  contextId: string
  name: CoreLevelFeatureNames
}
